<template>
	<div class="title">
		<div class="title__header">
			<div class="title__area">
				<div class="title__title">
					<h1>That Jifing Good</h1>
				</div>
				<div class="title__content">
					<h2>The <span>JIF THAT DISH<sup>&trade;</sup></span> Wheel</h2>
					<div v-html="introText">
					</div>
				</div>
			</div>
			<Controls @controlChange="handleControlChange" :filter-groups="filterGroups" />
		</div>
		<div class="title__footer">
			<DesktopFooter />
		</div>
	</div>
</template>

<script>
import Controls from './Controls'
import DesktopFooter from './DesktopFooter'

export default {
	name: 'Title',
	props: {
		introText: {
			type: String,
			default: ``
		},
		filterGroups: {
			type: Array,
			default: () => []
		}
	},
	components: {
		Controls,
		DesktopFooter
	},
	methods: {
		handleControlChange(controls) {
			this.$emit('handleControlChange', controls)
		}
	},
}
</script>

<style lang="scss">

@import "../styles/_colors.scss";
@import "../styles/_variables.scss";
@import "../styles/_mixins.scss";
@import "../styles/vendor/_index.scss";

.title {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.title__header {
	// transform: translateY(30px);
	padding-top: 30px;
	@include breakpoint(medium) {
		transform: translateY(30px);
	}
	@include breakpoint(large) {

	}
}
.title__area {
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: $transWhite;
	transform: skewY(-10deg);
	transform-origin: top left;
	padding: 1.25em 2.5em 1.25em 1em;
	overflow: hidden;
	h2 {
		font-size: em(28);
		line-height: 1;
		// max-width: 80%;
		span {
			font-size: 1.5em;
		}
	}
	p {
		color: $blue;
	}
	@include breakpoint(medium) {
		padding: 2em 2.5em 1.5em 1em;
	}
	@include breakpoint(large) {
		margin-top: 75px;
		margin-right: -3vw;
		h2 {
			// max-width: 78%;
			// max-width: 6em;
			font-size: em(30);
		}
	}
	@include breakpoint($xxlarge){
		h2 {
			font-size: em(40);
		}
	}
}
.title__title {
	// transform: skewY(10deg); // counter skew
	// flex: 0 0 calc(45% - 1em);
	// width: calc(45% - 1em);
	// margin-right: 1em;
	// & > div {
	// 	svg {
	// 		width: 100%;
	// 		height: auto;
	// 	}
	// }
	h1 {
		@include visually-hidden;
	}
	@include breakpoint(medium) {
		// flex: 0 0 140px
	}
	@include breakpoint(large) {
		// flex: 1 1 188px;
	}
}
.title__content {
	// flex: 0 0 60%;
	flex: 0 0 88%;
}
.title__footer {
	display: none;
	@include breakpoint(large) {
		display: block;
		margin-right: -3vw;
		// padding: 1em;
		// background-color: $transWhite;
	}
}

</style>